// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UnbxdCard-module__wrapper","blueBorder":"UnbxdCard-module__blueBorder"};